// @flow
import React from 'react'
import moment from 'moment'
import FormButtons from 'components/FormButtons'
import { fetchAccountHTTP } from 'lib/account/actions'
import { httpPost } from 'lib/http'
import { unsetModal } from 'lib/modal/actions'
import { setBanner, setLoad, setUnload } from 'lib/notification/actions'
import type { Form } from 'lib/types'
import styles from './styles'

type Props = {
  accountNumber: number,
  dispatch: Function,
  form: Form,
}

type State = {
  date: Date,
  isDeceasedDateUnknown: boolean,
  isNotDeceased: boolean,
}

class ClosingTrackForm extends React.Component<Props, State> {
  props: Props

  state = { date: '', isDeceasedDateUnknown: false, isNotDeceased: false }

  _wrapSubmit = () => (event) => {
    event.preventDefault()
    this._onSubmit()
  }

  _onSubmit = () => {
    const { accountNumber, dispatch } = this.props
    let dod = this.state.date

    if (this.state.isDeceasedDateUnknown) {
      dod = '1900-01-01'
    } else if (this.state.isNotDeceased) {
      dod = null
    }

    dispatch(setLoad())

    return httpPost(`/admin/closings/${accountNumber}`, { date_of_death: dod })
      .then(() => {
        dispatch(fetchAccountHTTP(accountNumber))
        dispatch(setBanner('Closing track started'))
      })
      .catch(() => {
        dispatch(setBanner('Closing track start error', 'danger'))
      })
      .then(() => {
        dispatch(unsetModal())
        dispatch(setUnload())
      })
  }

  _handleDateChange = ({ target }) => {
    this.setState({ date: target.value, isDeceasedDateUnknown: false, isNotDeceased: false })
  }

  _handleDeceasedDateUnknown = ({ target }) => {
    this.setState({ date: '', isDeceasedDateUnknown: target.checked, isNotDeceased: false })
  }

  _handleNotDeceased = ({ target }) => {
    this.setState({ date: '', isDeceasedDateUnknown: false, isNotDeceased: target.checked })
  }

  _canSubmit = () => {
    const dodMoment = moment(this.state.date)
    return this.state.isDeceasedDateUnknown || this.state.isNotDeceased || dodMoment.isValid()
  }

  render() {
    return (
      <section>
        <h4 className={styles.section}>Begin Closing Track</h4>
        <form onSubmit={this._wrapSubmit()}>
          <div className={styles.section}>
            <label className={styles.label} htmlFor="date">
              Date of death
            </label>
            <div className={styles.formItemQuarter}>
              <input className={styles.input} id="date" name="date" onChange={this._handleDateChange} type="date" value={this.state.date} />
            </div>
            <div className={styles.inputLabelGroup}>
              <input
                id="deceased_date_unknown"
                name="deceased_date_unknown"
                type="checkbox"
                checked={this.state.isDeceasedDateUnknown}
                onChange={this._handleDeceasedDateUnknown}
              />
              <label htmlFor="deceased_date_unknown">Deceased, date unknown</label>
            </div>
            <div className={styles.inputLabelGroup}>
              <input id="not_deceased" name="not_deceased" type="checkbox" checked={this.state.isNotDeceased} onChange={this._handleNotDeceased} />
              <label htmlFor="not_deceased">Not deceased</label>
            </div>
          </div>
          <FormButtons submitLabel={'Submit'} disabled={!this._canSubmit()} />
        </form>
      </section>
    )
  }
}

export default ClosingTrackForm
